<template>
  <div class="mainCainter">
    <!-- <van-popup round :close-on-click-overlay="false" v-model="ifshow"> -->
    <div class="mask" v-show="ifshow">
      <div class="cainter">
        <div class="moduleMian">
          <div class="successImg" id="demoCanvas" ref="demoCanvas">
            <div class="tip">{{ num }}<span>S</span></div>
            <div class="close" @click="closeShow">
              <img src="../../../../assets/img/moduleClose.png" alt="" />
            </div>
          </div>
          <!-- <div class="successImg"></div> -->
        </div>
      </div>
    </div>
    <!-- </van-popup> -->
  </div>
</template>
<script>
import SVGA from "svgaplayerweb";

export default {
  props: ["ModuleShow", "phone"],
  data() {
    return {
      ifshow: false,
      time: null,
      num: 6,
      NumberTime: null,

      bgImg: this.$commonUrl.cos() + "/image/redTickte.svga",
    };
  },
  watch: {
    ModuleShow: {
      //深度监听，可监听到对象、数组的变化
      handler(val) {
        this.ifshow = val;
        if (val) {
          this.start();
          this.SVGA();
          this.setFill();
        } else {
          this.num = 6;
        }
      },
      deep: true, //true 深度监听
    },
  },
  mounted() {
    this.ifshow = this.ModuleShow;
    // this.start();
    // this.SVGA();
    // this.setFill();
  },
  methods: {
    SVGA() {
      let player = new SVGA.Player("#demoCanvas");
      let parser = new SVGA.Parser("#demoCanvas");
      parser.load(this.bgImg, function (videoItem) {
        //this.bgImg，图片路径需要线上地址，本地引用会报错
        player.setVideoItem(videoItem);
        player.startAnimation();
      });
    },
    setFill() {
      //适配不同屏
      var $_canvas = document.getElementById("demoCanvas"),
        w = window.innerWidth,
        h = window.innerHeight,
        screen_proportion = h / w,
        svga_proportion = 16 / 9;
      if (screen_proportion > svga_proportion) {
        //长屏幕
        $_canvas.style.width = "100%";
        // $_canvas.style.height = h / screen_proportion + "px";
        $_canvas.style.height = h / 2 + "px";
      } else {
        $_canvas.style.height = w * svga_proportion + "px";
        // $_canvas.style.top = (h - w * svga_proportion) / 2 + "px";
        $_canvas.style.top = h / 2 + "px";
      }
    },

    //分享弹窗关闭
    closeShow() {
      this.ifshow = false;
      this.end();
      this.$emit("closeShowTickte", false);
    },
    startNumber() {
      let that = this;
      let num = this.num * 1000;
      this.NumberTime = setInterval(function () {
        that.closeShow();
      }, num);
    },
    start() {
      let that = this;
      this.startNumber();
      this.time = setInterval(function () {
        if (that.num > 0) {
          that.num--;
        }
      }, 1000);
    },
    end() {
      clearInterval(this.time);
      clearInterval(this.NumberTime);
    },
  },
};
</script>
<style lang="less" scoped>
.mainCainter {
  .mask {
    height: 100%;
    width: 100%;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 999;
  }
  .cainter {
    background-color: rgba(255, 255, 255, 0);
    width: 100%;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .moduleMian {
      text-align: center;
      border-radius: 15px;
      color: #df602f;
      padding: 20px 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .tip {
        width: 43px;
        height: 20px;
        line-height: 20px;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        font-size: 14px;
        text-align: center;
        color: #fff;
        position: absolute;
        top: 30%;
        right: 60px;
        z-index: 9;
        span {
          font-size: 10px;
        }
      }
      .successImg {
        min-height: 600px;
        max-width: 100%;
        margin: 0 auto;
      }
    }
    .close {
      width: 38px;
      height: 38px;
      margin: 0 auto 0;
      position: absolute;
      bottom: 15%;
      left: 50%;
      transform: translate(-50%, 0);
      img {
        width: 100%;
      }
    }
  }
}
</style>
